// Detects the user's US state code from their IP via a free geolocation endpoint.
// Returns a 2-letter code (e.g. "OH") when available and inside the US, otherwise null.
// Cached in sessionStorage so we don't re-hit the API on every render.

const SESSION_KEY = "rpt_detected_state";

export async function detectUsState() {
    try {
        const cached = sessionStorage.getItem(SESSION_KEY);
        if (cached) return cached === "__NONE__" ? null : cached;
    } catch {}
    try {
        const r = await fetch("https://ipapi.co/json/", { cache: "no-store" });
        if (!r.ok) throw new Error("geo fetch failed");
        const j = await r.json();
        const isUS = (j.country_code || j.country || "").toUpperCase() === "US";
        const code = (j.region_code || "").toUpperCase();
        const resolved = isUS && /^[A-Z]{2}$/.test(code) ? code : null;
        try { sessionStorage.setItem(SESSION_KEY, resolved || "__NONE__"); } catch {}
        return resolved;
    } catch {
        return null;
    }
}
